import { css, unsafeCSS } from 'lit';
import SotbitButton from '../button';
import styles from './button-pagination.scss?inline';

export default class SotbitButtonPagination extends SotbitButton {
    static styles = [
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = SotbitButton.properties;
}
